import script from "./BusinessSolutionsEvaluations.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessSolutionsEvaluations.vue?vue&type=script&setup=true&lang=js"

import "./BusinessSolutionsEvaluations.vue?vue&type=style&index=0&id=20ce7df3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ce7df3"]])

export default __exports__